export const PAGE_CONFIG_COMPONENT_LIMIT = 8;

export const ENTERPRISE_PAGE_CONFIG_COMPONENT_LIMIT = 3;

export const FETCH_MORE_COMPONENT_LIMIT = 10;
